export const Term = {
  TERMS_OF_SERVICE: '이용약관',
  PRIVACY_CONSENT: '개인정보처리방침',
} as const;

export type TermType = keyof typeof Term;
